import { createAction } from '@reduxjs/toolkit';

export const changeFilter = createAction("phoneBook/changeFilter");
export const editContact = createAction("phoneBook/editContact");